export default {
  namespaced: true,
  state: {
    sidebarExpanded: JSON.parse(window.localStorage.getItem('fullSidebar')),
  },
  getters: {
    user: state => state.user,
    sidebarExpanded: state =>  state.sidebarExpanded,
  },
  mutations: {
    setSidebarState(state) {
      state.sidebarExpanded = (state.sidebarExpanded === null) ? false : !state.sidebarExpanded;
      window.localStorage.setItem('fullSidebar', state.sidebarExpanded);
    },
  },
  actions: {
    toggleSidebar({ commit }) {
      commit('setSidebarState');
    },
  },
  modules: {},
};
